import React from "react";

export default function PrintableClientsTable({
    rows = [],
    title = "Clients",
    subtitle,
}) {
    const formatDate = (iso) => {
        if (!iso) return "";
        const d = new Date(iso);
        return Number.isNaN(d.getTime()) ? iso : d.toLocaleString();
    };

    return (
        // This wrapper can "break out" of narrow parent containers
        <div className="print-root">
            <div className="print-sheet">
                {/* Screen-only controls */}
                <div className="no-print controls">
                    <button type="button" onClick={() => window.print()}>
                        Print
                    </button>
                    <div className="meta">
                        Rows: <strong>{rows.length}</strong>    Printed:{" "}
                        <strong>{new Date().toLocaleString()}</strong>
                    </div>
                </div>

                <div className="header">
                    <h1>{title}</h1>
                    {subtitle && <div className="subtitle">{subtitle}</div>}
                    <div className="print-only meta">
                        Rows: {rows.length} � Printed: {new Date().toLocaleString()}
                    </div>
                </div>

                <table className="table">
                    <thead>
                        <tr>
                            <th>Client Name</th>
                            <th>Alt ID</th>
                            <th># Docs</th>
                            <th>Status</th>
                            <th>Last Upload</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="empty">
                                    No rows to print
                                </td>
                            </tr>
                        ) : (
                            rows.map((r) => (
                                <tr key={r.clientID}>
                                    <td className="wrap">{r.clientName}</td>
                                    <td className="wrap">{r.clientAltID}</td>
                                    <td className="num">{r.numDocs}</td>
                                    <td>{r.documentStatus}</td>
                                    <td>{formatDate(r.lastUpload)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <style>{`
        /* ===== GLOBAL-SAFE RESET (keeps it clean) ===== */
        .print-root, .print-root * {
          box-sizing: border-box;
          background: #fff !important;
          color: #000 !important;
          box-shadow: none !important;
          text-shadow: none !important;
          outline: none !important;
          border-radius: 0 !important;
        }

        /* ===== BREAK OUT OF NARROW PARENTS FOR PREVIEW =====
           If your preview is inside a centered container, this makes the report
           span the viewport width anyway.
        */
        .print-root {
          position: relative;
          width: 100%;
        }

        .print-sheet {
          /* Full-width preview (viewport) */
          width: 100vw;
          max-width: 100vw;
          /* Centered relative to viewport */
          margin-left: calc(50% - 50vw);
          margin-right: calc(50% - 50vw);

          /* No outer border */
          border: none !important;

          font-family: Arial, Helvetica, sans-serif;
        }

        /* ===== CONTROLS + HEADER ===== */
        .controls {
          padding: 12px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
        }

        button {
          border: 1px solid #000;
          background: #fff;
          color: #000;
          padding: 6px 12px;
          font-size: 14px;
          cursor: pointer;
        }

        .header {
          padding: 8px 16px 8px 16px;
          border: none !important; /* ensure no accidental outer border */
        }

        .header h1 {
          margin: 0;
          font-size: 20px;
          font-weight: 700;
        }

        .subtitle {
          font-size: 13px;
          margin-top: 2px;
        }

        .meta {
          font-size: 12px;
          margin-top: 4px;
        }

        /* ===== TABLE ===== */
        .table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;
          border: none; /* no table outer border beyond cell borders */
        }

        .table th,
        .table td {
          border: 1px solid #000; /* gridlines */
          padding: 6px 8px;
          font-size: 12px;
          vertical-align: top;
        }

        .table th {
          font-weight: 700;
          text-align: left;
        }

        .wrap {
          word-break: break-word;
          overflow-wrap: anywhere;
        }

        .num {
          text-align: right;
          white-space: nowrap;
        }

        .empty {
          text-align: center;
          padding: 16px;
        }

        /* ===== PRINT ===== */
        .print-only { display: none; }

        @media print {
          @page {
            size: portrait;
            margin: 0.5in; /* adjust if you want tighter margins */
          }

          .no-print { display: none !important; }
          .print-only { display: block; }

          /* In print, use the printable area width, not 100vw tricks */
          .print-sheet {
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
          }

          thead { display: table-header-group; }
          tr { page-break-inside: avoid; }
        }
      `}</style>
        </div>
    );
}

